export default __webpack_public_path__ + "static/media/wha.71c13a6d.mp4";